import { Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";
import { LogoutButton } from "@/components/ProfileMenu";
import { Loader2, ShieldAlert } from "lucide-react";
import { homePath, useMe } from "@/context/MeContext";
import { Button } from "@/components/ui/button";

export const Spinner = ({ label = "Loading" }) => (
  <div className="flex min-h-[40vh] items-center justify-center gap-2 text-slate-500" data-testid="loading-indicator">
    <Loader2 className="h-5 w-5 animate-spin" /> <span className="text-sm">{label}…</span>
  </div>
);

function Blocked({ message }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 p-6 text-center" data-testid="account-blocked">
      <ShieldAlert className="h-10 w-10 text-rose-600" />
      <p className="text-slate-700">{message}</p>
      <LogoutButton className="border border-slate-300" testid="blocked-signout-btn" />
    </div>
  );
}

function Inner({ roles, allowSetup, children }) {
  const { me, error } = useMe();
  const loc = useLocation();
  if (error && !me) return <Blocked message={error} />;
  if (!me) return <Spinner />;
  const target = homePath(me);
  const ready = !["/welcome", "/onboarding/learner", "/onboarding/employer"].includes(target);
  if (!allowSetup && !ready && loc.pathname !== target) return <Navigate to={target} replace />;
  if (roles && !roles.includes(me.user.role) && !(me.user.is_admin && roles.includes("admin"))) return <Navigate to={target} replace />;
  return children;
}

export function Protected(props) {
  return (
    <>
      <Show when="signed-in"><Inner {...props} /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}

export function HomeRedirect({ landing }) {
  const { state } = useLocation();
  if (state?.home) return landing;
  return (
    <>
      <Show when="signed-in"><HomeTarget /></Show>
      <Show when="signed-out">{landing}</Show>
    </>
  );
}

function HomeTarget() {
  const { me, error } = useMe();
  if (error && !me) return <Blocked message={error} />;
  if (!me) return <Spinner />;
  return <Navigate to={homePath(me)} replace />;
}
